import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ComponentStore } from '@ngrx/component-store';
import { SubSink } from 'subsink2';
import Quagga from 'quagga';
import * as $ from 'jquery';
import { SerialNumberStatus } from '../../../models/serial-number.model';

interface LocalState {
  quaggaStatus: 'idle' | 'initializing' | 'ready';
}

@Component({
  selector: 'app-util-serial-number-scan-optional',
  templateUrl: './serial-number-scan-optional.component.html',
  styleUrls: ['./serial-number-scan-optional.component.css']
})
export class SerialNumberScanOptionalComponent implements OnInit, OnDestroy {
  @Input() noDefaultValue : boolean;
  @Input() postingStatus;
  @Output() serialNumber = new EventEmitter<string>();
  @Output() serialNumberList = new EventEmitter<any[]>();

  private subs = new SubSink();

  readonly quaggaStatus$ = this.componentStore.select(state => state.quaggaStatus);

  form: FormGroup;
  delimiter: string;
  invalid: boolean;
  newList: any []=[];

  constructor(
    private readonly componentStore: ComponentStore<LocalState>) {
    this.componentStore.setState({
      quaggaStatus: 'idle',
    });
  }

  ngOnInit() {
    this.form = new FormGroup({
      serialNumber: new FormControl(),
      delimiter: new FormControl(null),
      from: new FormControl(),
      to: new FormControl(),
      readers: new FormControl('code_128_reader'),
    });
  }

  onScan() {
    this.componentStore.patchState(state => ({ ...state, quaggaStatus: 'initializing' }));
    this.form.controls['readers'].disable();
    Quagga.init({
      inputStream : {
        name : 'Live',
        type : 'LiveStream',
        target: document.querySelector('#camera')
      },
      decoder : {
        readers : [this.form.getRawValue().readers]
      }
    }, (err) => {
        if (err) {
            console.error(err);
            return;
        }
        $('video').css({
          'width': '100%',
          'border': 'mediumslateblue 4px solid',
          'border-radius': '10px'
        });
        $('canvas').remove();
        $('#camera').show();
        this.componentStore.patchState(state => ({...state, quaggaStatus: 'ready'}));
        Quagga.start();
    });
    Quagga.onDetected((data) => {
      this.componentStore.patchState(state => ({
        ...state,
      }));
      this.serialNumber.emit(data.codeResult.code);
      $('#camera').hide();
      this.componentStore.patchState(state => ({...state, quaggaStatus: 'idle'}));
      Quagga.stop();
      this.form.controls['readers'].enable();
    });
  }

  onStop() {
    $('#camera').hide();
    this.componentStore.patchState(state => ({...state, quaggaStatus: 'idle'}));
    Quagga.stop();
    this.form.controls['readers'].enable();
  }

  onDelimiterSelected(event) {
    this.delimiter = event;
  }

  onAdd(fromScanner ?: string) {
    // input from scanner
    if (fromScanner) this.addSingleSNToList(fromScanner);
  
    const input = this.form.controls['serialNumber'].value;
    if (input && !fromScanner) {
      if (this.delimiter) {
        input.split(this.delimiter).forEach(sn => this.addSingleSNToList(sn.toUpperCase()));
      } else {
        this.addSingleSNToList(input.toUpperCase());
      }
    }
    this.form.controls['serialNumber'].reset();
  }

  onAddRange() {
    const from = this.form.controls['from'].value;
    const to = this.form.controls['to'].value;
    const regex = /\d*$/;
    if (from && to && from.split(regex)[0] === to.split(regex)[0] && from.match(regex) && to.match(regex)) {
      const first = parseInt(from.match(regex)[0], 10);
      const last = parseInt(to.match(regex)[0], 10);
      
      if (first && last && last > first && last - first < 2000) {
        const prefix = from.split(regex)[0];
        const arr = Array.from(Array(last - first + 1), (_, a) => `${prefix}${(first + a).toString().padStart(3, '0')}`);
        console.log('onAddRange', arr);
        arr.map(s => this.mapToSerialNumberObject(s));
        if (this.newList.length > 0) {
          this.addMultiSNToList(this.newList);
        }
        this.form.controls['from'].reset();
        this.form.controls['to'].reset();
      }
    }
  }

  mapToSerialNumberObject(sn: string){
    const snObj = new SerialNumberStatus();
    snObj.sn_id = sn.toUpperCase().trim();
    snObj.status = "VALIDATION_IN_PROGRESS";
    this.newList.push(snObj);
   }

  addSingleSNToList(sn: string ) {
    this.serialNumber.emit(sn);
  }

  addMultiSNToList(sn: string []) {
    this.serialNumberList.emit(sn);
  }

  disableAdd(){
    return this.postingStatus==="FINAL"
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}